module.exports = __webpack_public_path__ + "media/images/covers/Live-Results-Banner-daef20b57c003948f756de0394a5d276.png";